import { Link } from "react-router-dom";
import { useState } from "react";

const footerLinks = [
  { label: "首页", path: "/" },
  { label: "明星八卦", path: "/category/star-gossip" },
  { label: "综艺内幕", path: "/category/variety-insider" },
  { label: "影视爆料", path: "/category/film-tv-leaks" },
  { label: "关于我们", path: "/about" },
];

const policyLinks = [
  { label: "隐私政策", path: "/about" },
  { label: "用户协议", path: "/about" },
  { label: "投稿规范", path: "/about" },
  { label: "免责声明", path: "/about" },
];

function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "submitting" | "done">("idle");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotEl = form.querySelector('input[name="company_alt"]') as HTMLInputElement;
    if (honeypotEl && honeypotEl.value.trim() !== "") {
      setStatus("done");
      return;
    }

    setStatus("submitting");

    try {
      const body = new URLSearchParams();
      body.append("email", email);

      await fetch("https://readdy.ai/api/form/d913jhk6ci2plld1oi80", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
    } catch {
      // still show success
    }

    setStatus("done");
  };

  if (status === "done") {
    return (
      <div className="flex items-center gap-2 px-3 py-2.5 rounded-lg bg-primary-500/20 border border-primary-500/30">
        <i className="ri-check-line text-primary-400 text-sm"></i>
        <span className="text-xs text-primary-300">订阅成功!</span>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} data-readdy-form="">
      <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
      <div className="flex gap-2">
        <input
          type="email"
          name="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="输入邮箱地址"
          className="flex-1 px-3 py-2.5 rounded-lg bg-foreground-800 text-sm text-background-50 placeholder:text-background-50/30 border border-foreground-700 focus:outline-none focus:border-primary-500 transition-colors"
        />
        <button
          type="submit"
          disabled={status === "submitting"}
          className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors flex-shrink-0 disabled:opacity-60"
        >
          <i className={`${status === "submitting" ? "ri-loader-4-line animate-spin" : "ri-arrow-right-line"} text-background-50 text-lg`}></i>
        </button>
      </div>
    </form>
  );
}

export default function Footer() {
  return (
    <footer className="relative bg-foreground-900 text-background-50/80 overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-5 group">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white tracking-wide">
                51吃瓜网
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              全网最新最热的吃瓜爆料平台，
              <br />
              明星八卦、综艺内幕、影视爆料，
              <br />
              每日更新，吃瓜不迷路。
            </p>
          </div>

          {/* Nav Links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">导航频道</h4>
            <div className="flex flex-col gap-2.5">
              {footerLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Policy Links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              {policyLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.path}
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Subscribe */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">订阅爆料</h4>
            <p className="text-sm text-background-50/60 mb-4 leading-relaxed">
              第一时间获取最新瓜料，
              <br />
              不错过任何精彩爆料。
            </p>
            <NewsletterForm />
          </div>
        </div>

        {/* Bottom Brand Watermark */}
        <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 51吃瓜网 csxsjds.cn 版权所有
          </p>
          <div className="text-4xl font-heading font-black text-background-50/5 select-none whitespace-nowrap">
            51CG
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors text-lg" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors text-lg" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors text-lg" aria-label="抖音" rel="nofollow">
              <i className="ri-tiktok-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute right-0 bottom-0 opacity-[0.03] pointer-events-none select-none text-[180px] font-heading font-black leading-none whitespace-nowrap overflow-hidden">
        51CG
      </div>
    </footer>
  );
}
